import React from 'react';
import { useNavigate } from 'react-router-dom';

const AplicarTutor = () => {
  const navigate = useNavigate();
  const videoId = 'oZoLavQu5Ls';
  const aplicarRegistro = async () => {
    navigate('/registro/formulario');
  }

  return (
    <div className="max-w-3xl mx-auto my-5 bg-white rounded-lg shadow-md overflow-hidden font-sans">
      <div className="bg-blue-500 text-white p-5 text-center relative">
        <div className="absolute left-5 bottom-5 text-2xl">∑ ÷ ∞</div>
        <h1 className="text-5xl my-2">EduSmart</h1>
        <div className="absolute right-5 bottom-5 text-2xl">🎓 📚</div>
      </div>

      <div className="p-5 leading-relaxed">
        <p className="text-2xl font-bold text-center">📚 🧠 ✨ Únete a Nuestro Equipo de Tutores en EduSmart ✨ 🧠 📚</p>
        
        <p className="mt-4 text-center">Gracias por tu interés. Estás a un paso de integrarte a una red de profesionales que transforma la experiencia académica en Latinoamérica.</p>
        
        <p className="mt-4">En EduSmart, hemos consolidado la trayectoria y el alcance de cuatro marcas líderes en el sector educativo:</p>
        
        <div className="my-5 grid grid-cols-2 gap-3 text-center">
          <a href="https://www.instagram.com/dufyasesorias/" target="_blank" rel="noopener noreferrer" className="p-2 border rounded-lg text-blue-600 hover:bg-blue-50 hover:underline transition-all duration-200">🦉 Dufy Asesorías</a>
          <a href="https://www.instagram.com/tesifive/" target="_blank" rel="noopener noreferrer" className="p-2 border rounded-lg text-blue-600 hover:bg-blue-50 hover:underline transition-all duration-200">🐴 TesiFive</a>
          <a href="https://www.instagram.com/unially_/" target="_blank" rel="noopener noreferrer" className="p-2 border rounded-lg text-blue-600 hover:bg-blue-50 hover:underline transition-all duration-200">🌳 UniAlly</a>
          <a href="https://www.instagram.com/reyesasesorias/" target="_blank" rel="noopener noreferrer" className="p-2 border rounded-lg text-blue-600 hover:bg-blue-50 hover:underline transition-all duration-200">👑 Reyes Asesorías</a>
        </div>
        
        <p className="mt-3">Esta sinergia se traduce en un mayor volumen de oportunidades y una diversificada cartera de proyectos académicos disponibles para ti. 💫</p>
        
        <h3 className="text-xl font-semibold mt-6 mb-3 text-center">Nuestro Modelo de Colaboración</h3>
        
        <div className="bg-gray-50 p-4 rounded-lg my-4 border border-gray-200">
          <p>Operamos bajo un <strong>modelo de colaboración freelance</strong>, diseñado para ofrecerte autonomía y flexibilidad.</p>
          <p className="mt-2">Esto te permite integrar tu participación en la plataforma con tus otras actividades profesionales o académicas. Tus ingresos son un reflejo directo de tu actividad y de los proyectos que gestiones. Nuestros tutores más activos pueden generar ingresos superiores a <strong>$2.000.000 COP</strong> mensuales, demostrando el potencial de este modelo dinámico.</p>
        </div>

        {/* ====== NUEVA UBICACIÓN RECOMENDADA PARA EL VIDEO ====== */}
        <div className="w-full aspect-video my-8 rounded-lg overflow-hidden shadow-lg">
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/oZoLavQu5Ls`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
        
        <h3 className="text-xl font-semibold mt-6 mb-3 text-center">¿Cómo Funciona el Proceso?</h3>
        <ol className="list-decimal list-inside space-y-2">
            <li><strong>Registro y Perfil Profesional:</strong> Completa tu registro para destacar tus áreas de especialización.</li>
            <li><strong>Recepción de Solicitudes:</strong> Accede a un flujo de oportunidades académicas compatibles con tu perfil.</li>
            <li><strong>Valoración de Servicios:</strong> 🚀 Tienes la autonomía para cotizar cada solicitud. El valor propuesto constituye tu ganancia.</li>
            <li><strong>Finalización y Pago:</strong> 💸 Recibe tu pago de forma segura tras la finalización exitosa de cada proyecto.</li>
        </ol>
        
        <p className="mt-6">Te invitamos a completar el formulario para iniciar tu postulación. Únete a nuestra creciente <strong>comunidad de expertos independientes</strong> y contribuye con tu talento al éxito de futuros profesionales.</p>
        
        <div className="text-center mt-8 mb-5">
          <button 
            onClick={aplicarRegistro}
            className="bg-blue-500 hover:bg-blue-600 text-white border-none py-3 px-10 text-lg font-bold rounded-full cursor-pointer transition-colors duration-300 shadow-lg hover:shadow-xl">
            Iniciar mi Postulación
          </button>
        </div>
      </div>
    </div>
  );

};

export default AplicarTutor;